import { ACTION_TYPE } from '../../store/actionCreatorsHelpers';

export function track(interaction: string) {
    return {
        type: ACTION_TYPE.TRACK,
        interaction,
    };
}

export function clickLink(appId: string, url: string) {
    return {
        type: ACTION_TYPE.CLICK_LINK,
        appId,
        url,
    };
}
